const React = require("react");
const { usePrintify } = require("../context/PrintifyContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;

const SellerPrintifySettings = () => {
  const { api, t } = usePrintify();
  const resource = useResource(() => api.getConnection(), [api]);
  const [shopId, setShopId] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const connection = resource.data?.connection;
  React.useEffect(() => { if (connection?.shopId) setShopId(connection.shopId); }, [connection?.shopId]);
  const action = async (callback, success) => {
    setBusy(true); setError(""); setMessage("");
    try { await callback(); setMessage(success); await resource.reload(); }
    catch (requestError) { setError(requestError.message); }
    finally { setBusy(false); }
  };
  return h(React.Fragment, null,
    h(PageHeader, { title: t("h_printify_settings", "Printify settings"), description: t("h_printify_settings_desc", "Choose the primary shop used for product synchronization and order fulfillment.") }),
    message ? h("div", { className: "pyds-success" }, message) : null,
    error ? h("div", { className: "pyds-alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !connection, reload: resource.reload, t }, connection ? h("div", { className: "pyds-form" },
      h("div", { className: "pyds-row pyds-between" }, h("h3", null, connection.accountName || "Printify"), h(StatusBadge, { status: connection.status, t })),
      h("div", { className: "pyds-field" },
        h("label", { htmlFor: "printify-primary-shop" }, t("h_printify_primary_shop", "Primary shop")),
        h("select", { id: "printify-primary-shop", className: "pyds-input", value: shopId, onChange: (event) => setShopId(event.target.value) },
          ...(connection.shops || []).map((shop) => h("option", { value: shop.shopId, key: shop.shopId }, `${shop.title}${shop.salesChannel ? ` · ${shop.salesChannel}` : ""}`))
        )
      ),
      h("div", { className: "pyds-row" },
        h(Button, { disabled: busy || !shopId || shopId === connection.shopId, onClick: () => action(() => api.selectShop(shopId), t("h_printify_shop_changed", "Primary Printify shop updated.")) }, t("h_printify_save_shop", "Save shop")),
        h(Button, { variant: "secondary", disabled: busy, onClick: () => action(api.refreshShops, t("h_printify_shops_refreshed", "Printify shops refreshed.")) }, t("h_printify_refresh_shops", "Refresh shops")),
        h(Button, { variant: "secondary", disabled: busy, onClick: () => action(api.syncAll, t("h_printify_sync_ok", "Printify synchronization completed.")) }, t("h_printify_sync", "Synchronize")),
        h(LinkButton, { to: "/dropshipping/printify/connect", variant: "secondary" }, t("h_printify_connection", "Connection"))
      ),
      h("p", { className: "pyds-muted" }, `${t("h_printify_last_sync", "Last synchronization")}: ${connection.lastSync ? new Date(connection.lastSync).toLocaleString() : "—"}`)
    ) : null)
  );
};

module.exports = { SellerPrintifySettings };
